import { useMutation, useSuspenseQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { FacilityWasteView } from "generated-graphql/graphql";

import { useWasteFacilityState } from "../WasteFacilityContext";

export const GET_WASTE_STREAM = gql(`
  query GetWasteStream(
    $id: ID!
    $startDate: Date
    $endDate: Date
    $view: FacilityWasteView
    $tags: [String!]
  ) {
    wasteStream(id: $id, startDate: $startDate, endDate: $endDate, view: $view, tags: $tags) {
      id
      name
      facilityId
      classification
      federalWasteCodes
      stateWasteCodes
      eManifestProfileNumber
      vendorProfileNumber
      managementMethodCodes
      formCode
      sourceCode
      wasteMinimizationCode
      vendorFormCode
      eManifestFormCode
      vendorSourceCode
      eManifestSourceCode
      vendorAmount
      eManifestAmount
      effectiveAmount
      vendorDotDescription
      eManifestDotDescription
      vendorManifestCount
      eManifestCount
      vendorManifestLineItemCount
      eManifestLineItemCount
      lastShipmentDate
      lastShipmentDateAllTime
      internalNote
      comment
      willNotReport
      mergeCount
    }
  }
`);

export const useWasteStream = (id: string) => {
  const {
    wasteFacilityState: { deferredFilters },
  } = useWasteFacilityState();
  const { startDate, endDate, view, tags } = deferredFilters;
  if (!startDate || !endDate || !view) {
    throw new Error("startDate, endDate, and view are required");
  }
  return useWasteStreamWithParams(id, startDate, endDate, view, tags);
};

export const useWasteStreamWithParams = (
  id: string,
  startDate: string,
  endDate: string,
  view: FacilityWasteView,
  tags: string[] | undefined
) => {
  return useSuspenseQuery(GET_WASTE_STREAM, {
    variables: { id, startDate, endDate, view, tags },
  });
};

export const UPDATE_WASTE_STREAM = gql(`
  mutation UpdateWasteStream($input: UpdateWasteStreamInput!) {
    updateWasteStream(input: $input) 
  }
`);

export const useUpdateWasteStream = () => {
  return useMutation(UPDATE_WASTE_STREAM, {
    refetchQueries: [GET_WASTE_STREAM],
  });
};
